import { render, staticRenderFns } from "./MyDashboard.vue?vue&type=template&id=18e751fe&"
import script from "./MyDashboard.vue?vue&type=script&lang=js&"
export * from "./MyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MyDashboard.vue?vue&type=style&index=0&id=18e751fe&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e751fe')) {
      api.createRecord('18e751fe', component.options)
    } else {
      api.reload('18e751fe', component.options)
    }
    module.hot.accept("./MyDashboard.vue?vue&type=template&id=18e751fe&", function () {
      api.rerender('18e751fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MyDashboard.vue"
export default component.exports